import React from 'react';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketDashboard } from '../components/MarketDashboard';
import { PorkPrimalsTable } from '../components/PorkPrimalsTable';
import { MarketIQNav } from '../components/MarketIQNav';
import { Activity, Calendar } from 'lucide-react';
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const generateCurve = (base: number, volatility: number, trend: number, length: number) => {
  let current = base;
  return Array.from({
    length
  }).map(() => {
    current += (Math.random() - 0.5) * volatility + trend;
    return Number(current.toFixed(2));
  });
};
const pork2024 = generateCurve(0.85, 0.03, 0.002, 12);
const pork2025 = generateCurve(0.9, 0.04, 0.005, 12);
const pork2026 = generateCurve(0.95, 0.03, 0.001, 4);
const porkData = months.map((month, i) => ({
  month,
  val2024: pork2024[i],
  val2025: pork2025[i],
  val2026: i < 4 ? pork2026[i] : null
}));
export function MarketIQPork() {
  return <MarketIQLayout activeSection="pork" data-id="element-577">
      <MarketDashboard label="PORK CUTOUT VALUES" title="Pork Cutout Values" subtitle="USDA Estimated Pork Carcass Cutout" chartTitle="Pork Cutout ($/lb) - Carcass, Daily" currentPrice="$0.98" currentPriceNum={0.98} priceChange={{
      value: '$0.01',
      isNegative: true
    }} historicalChanges={[{
      label: '1W',
      value: '+$0.02',
      isNegative: false
    }, {
      label: '1M',
      value: '$0.04',
      isNegative: true
    }, {
      label: '1Y',
      value: '+$0.01',
      isNegative: false
    }]} lastReportDate="Apr 7, 2026" filters={[{
      icon: <Activity className="w-4 h-4" data-id="element-579" />,
      label: 'Carcass'
    }, {
      icon: <Calendar className="w-4 h-4" data-id="element-580" />,
      label: 'Daily'
    }]} chartData={porkData} yAxisDomain={[0.81, 1.25]} yAxisTicks={[0.81, 0.9, 0.98, 1.07, 1.16, 1.25]} data-id="element-578" />
      <MarketIQNav current="pork" data-id="element-581" />
      <PorkPrimalsTable data-id="element-582" />
    </MarketIQLayout>;
}